/*
 *
 *  *
 *  *  Copyright (C) THL A29 Limited, a Tencent company. All rights reserved.
 *  *  SPDX-License-Identifier: Apache-2.0
 *  *
 *
 */

import React, { useState } from "react";
import style from "./index.module.scss";
import Between from "@components/ui/Between";
export default function Organization() {
  const [orgList] = useState([
    {
      name: "江苏激扬软件有限公司",
      node: "1节点",
      time: "2022-02-11 11:19:00",
    },
    {
      name: "省厅",
      node: "2节点",
      time: "2022-02-12 11:19:00",
    },
    {
      name: "交通",
      node: "3节点",
      time: "2022-02-13 11:19:00",
    },
    {
      name: "江北",
      node: "4节点",
      time: "2022-02-14 11:19:00",
    },
  ]);
  return (
    <div className={style.org}>
      <div className={style.org_title}>
        <Between title="区块组织" content="" />
      </div>
      <div className={style.org_list}>
        {orgList.length !== 0 &&
          orgList.map(({ name, node, time }, index) => (
            <div key={index} className={style.item}>
              <span className={style.org_flag}>{name.substring(0, 1)}</span>
              <span className={style.org_name}>{name}</span>
              <span className={style.org_node}>{node}</span>
              <span className={style.org_time}>{time}</span>
            </div>
          ))}
        {orgList.length === 0 && <div className="empty_list"></div>}
      </div>
    </div>
  );
}
